import React from "react";
import styled from "styled-components/macro";
import StyledButton from "./StyledButton";
import WebDescription from "./WebsiteDescription";
import WebOpenHouse from "components/Unit/WebsiteOpenhouse";
import { useMediaQuery } from "@mui/material";

// Outer wrapper section
const DescriptionSectionWrapper = styled.section`
  width: 100%;
  display: flex;
  justify-content: center;
  background: ${({}) => `${f_clr.secondaryColor}`};
  border-radius: 0 0 16px 16px;
  box-sizing: border-box;
  padding: 48px 24px;
  align-items: flex-start;

  @media only screen and (max-width: 1024px) {
    padding: 48px 0 24px;
  }

  @media only screen and (max-width: 600px) {
    padding: 24px 16px;
  }
`;

// Inner container to constrain width
const DescriptionSectionInner = styled.div`
  width: 100%;
  max-width: 1440px;
`;

// Open House box (hidden on mobile)
const OpenHouseWrapper = styled.div`
  display: flex;
  max-width: 432px;
  // padding: 16px 48px 16px 16px;
  flex-direction: column;
  align-items: flex-start;
  gap: 10px;
  // border-radius: 16px;
  // background: #ffffff;
  // box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
  // border: 4px solid #fff;

  @media (max-width: 960px) {
    display: none; /* 👈 Hide on mobile */
  }
`;

// Two-column layout
const TwoColumnRow = styled.div`
  display: flex;
  align-items: flex-start;
  gap: clamp(96px, 8vw, 160px);

  @media (max-width: 960px) {
    flex-direction: column;
    gap: 24px;
  }
`;

// Left column (main description)
const LeftCol = styled.div`
  flex: 1 1 0%;
  min-width: 0;
`;

// Right column (OpenHouse + Facts)
const RightCol = styled.div`
  max-width: 644px;
  width: 100%;

  @media (max-width: 960px) {
    max-width: 100%;
  }
`;

const Heading = styled.div`
  margin: 0 0 48px 0;
`;

const CtaWrapper = styled.div`
  display: flex;
  justify-content: center;
  padding-top: 48px;

  @media (max-width: 600px) {
    padding-top: 24px;
  }
`;

const HeaderDescription = ({ HomePageDescriptionBackgroundFrontpage: hdbf }) => {
  const isMobile = useMediaQuery("(max-width:960px)");

  return (
    <DescriptionSectionWrapper>
      <DescriptionSectionInner>
        <Heading className="h2">{hdbf?.[0]?.Headline}</Heading>

        <TwoColumnRow>
          <LeftCol>
            {/* On mobile → combine both text sections */}
            {isMobile ? (
              <WebDescription
                headerStyle={{ mb: "0" }}
                header=""
                content={`${hdbf?.[0]?.Text || ""}\n\n${hdbf?.[0]?.FactsText || ""}`}
                overlayColor={hdbf?.[0]?.CTAcolor}
                color="#000"
              />
            ) : (
              // On desktop → show main text only
              <WebDescription
                headerStyle={{ mb: "0" }}
                header=""
                content={hdbf?.[0]?.Text || ""}
                overlayColor={hdbf?.[0]?.CTAcolor}
                color="#000"
              />
            )}
          </LeftCol>

          {/* On desktop → show OpenHouse + Facts */}
          {!isMobile && (
            <RightCol>
              <OpenHouseWrapper>
                <WebOpenHouse />
              </OpenHouseWrapper>

              <WebDescription
                headerStyle={{ mb: "0" }}
                header=""
                content={hdbf?.[0]?.FactsText}
                overlayColor={hdbf?.[0]?.CTAcolor}
                color="#000"
              />
            </RightCol>
          )}
        </TwoColumnRow>

        <CtaWrapper>
          <StyledButton
            Linkto={hdbf?.[0]?.CTAlink}
            text={hdbf?.[0]?.CTAlabel || "Se ledige boliger"}
            showIcon
            $bgColor={hdbf?.[0]?.CTAcolor || "#ff6f3c"}
          />
        </CtaWrapper>
      </DescriptionSectionInner>
    </DescriptionSectionWrapper>
  );
};

export default HeaderDescription;
